module.exports = __webpack_public_path__ + "static/img/jrs.6148129.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jrs.jpg
// module id = 7fpe
// module chunks = 0